<template>
  <div>
    <div :class='[{ "is-active": isOpen }, "modal"]'>
      <div class='modal-background'></div>

      <div class='modal-card'>
        <header class='modal-card-head'>
          <h2 class='modal-card-title'>Selector Details</h2>
          <button class='delete' :disabled='isValidating' aria-label='close' @click='onClose'></button>
        </header>

        <section class='modal-card-body'>
          <ErrorNotification v-if='errors.length' :messages='errors' />

          <div v-if='showSuccessfulValidate' class="notification is-success">
            <button class="delete" @click='showSuccessfulValidate = false'></button>
            <p>Selector has been successfully validated.</p>
          </div>

          <label class='label'>FQDN</label>
          <div class='field has-addons'>
            <div class='control is-expanded'>
              <input
                readonly
                class='input'
                type='text'
                :value='selected.fqdn'
              />
            </div>
            <div class='control'>
              <a class='button' @click='copyToClipboard(selected.fqdn)'>Copy</a>
            </div>
          </div>

          <label class='label'>DNS TXT</label>
          <div class='field has-addons'>
            <div class='control is-expanded'>
              <input
                readonly
                class='input'
                type='text'
                :value='selected.txtValue'
              />
            </div>
            <div class='control'>
              <a class='button' @click='copyToClipboard(selected.txtValue)'>Copy</a>
            </div>
          </div>
        </section>

        <footer class='modal-card-foot'>
          <div style='width: 100%'>
            <button
              v-if='isAdmin'
              :class='[{ "is-loading": isValidating }, "button is-success"]'
              @click='$emit("validate")'
            >
              Validate
            </button>
            <button
              v-if='isAdmin'
              class='button is-danger is-outlined'
              :disabled='isValidating'
              @click='isConfirmDeleteOpen = true'
            >
              Delete
            </button>
            <button
              class='button is-cancel is-pulled-right'
              :disabled='isValidating'
              @click='$emit("close")'
            >
              Close
            </button>
          </div>
        </footer>

        <DeleteConfirmation
          :isOpen='isConfirmDeleteOpen'
          @confirm='onConfirmDelete'
          @cancel='isConfirmDeleteOpen = false'
        >
          <p>Are you sure you want to delete this selector?</p>
        </DeleteConfirmation>
      </div>
    </div>
  </div>
</template>

<script>
import { copyToClipboard } from '@/utils';
import ErrorNotification from '@/components/ErrorNotification.vue';
import DeleteConfirmation from '@/components/DeleteConfirmation.vue';

export default {
  name: 'SelectorDetails',

  components: {
    ErrorNotification,
    DeleteConfirmation
  },

  props: {
    isOpen: {
      type: Boolean,
      required: true
    },
    selected: {
      type: Object,
      required: true
    },
    isAdmin: {
      type: Boolean,
      required: true
    },
    errors: {
      type: Array,
      required: true
    },
    isValidating: {
      type: Boolean,
      required: true
    }
  },

  watch: {
    'selected.validatedAt': function(value, old) {
      this.showSuccessfulValidate = value && old && value !== old;
    }
  },

  data() {
    return {
      isConfirmDeleteOpen: false,
      showSuccessfulValidate: false
    }
  },

  methods: {
    copyToClipboard,

    onClose() {
      this.$emit('close');
    },

    onConfirmDelete() {
      this.$emit('delete');
      this.isConfirmDeleteOpen = false;
    }
  }
}
</script>